// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".value-from[data-v-17acfc7e] .v-select,.value-from[data-v-17acfc7e] INPUT:not(.vs__search){height:50px}.value-from[data-v-17acfc7e],.value-from-headers[data-v-17acfc7e]{display:grid;grid-template-columns:20% 20% 20% 5% 20% auto;grid-gap:1.75%;align-items:center;margin-bottom:10px}.value-from-headers[data-v-17acfc7e]{margin:10px 0 10px 0;color:var(--input-label)}", ""]);
// Exports
module.exports = exports;
